<template>
  <div>
    <modal-cadastro-modulo ref="modalCadastroModulo" :curso_id="curso_id"
                                                     :modulo-edicao="moduloEdicao"
                                                     :modulo_array_prop="modulo_array"
                                                     @moduloSalvo="moduloSalvo" />
    <modal-cadastro-licao ref="modalCadastroLicao" :curso_id="curso_id"
                                                   :modulo_id="modulo_id"
                                                   :licao-edicao="licaoEdicao"
                                                   :licao_array_prop="licao_array"
                                                   @licaoSalva="licaoSalva"
                                                   @licaoEditada="licaoEditada" />
    <modal-cadastro-topico ref="modalCadastroTopico" :curso_id="curso_id"
                                                     :modulo_id="modulo_id"
                                                     :licao_id="licao_id"
                                                     :topico-edicao="topicoEdicao"
                                                     :topico_array_prop="topico_array"
                                                     @topicoEditado="topicoEditado" />
    <modal-associa-resumo ref="modalAssociaResumo" :licao="licao"
                                                    @resumosAssociados="resumosAssociados"
                                                    @atualizaLicao="atualizaLicao"
                                                    :resumosExistentes="resumosExistentes" />
    <div class="tab-pane fade show active" id="pills-ementas" role="tabpanel" aria-labelledby="pills-ementas-tab">
      <div class="mt-5 mb-3">
        <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="modalCadastrarModulo()"><i class="fas fa-plus"></i> Adicionar Módulo</a>&#32;
      </div>
      <draggable
        :list="modulo_array"
        :disabled="!enabledModulo"
        class="list-group ementa-lista"
        ghost-class="ghost"
        @start="draggingModulo = true"
        @end="draggingModulo = false"
      >
        <div class="list-group-item modulo" v-for="(modulo, index) in modulo_array" :key="index">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center flex-grow-1 mr-3">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center flex-column mr-3">
                      <i class="fas fa-caret-up"></i>
                      <i class="fas fa-caret-down"></i>
                    </div>
                    <p>{{ modulo.modulo }}</p>
                  </div>
                  <div>
                    <a href="javascript:void(0)" class="btn btn-secondary mr-2" @click="modalCadastrarLicao(modulo.id)"><i class="fas fa-plus"></i> Adicionar lição</a>
                    <a href="javascript:void(0)" class="mr-2" @click="modalEdicaoModulo(modulo)"><i class="fas fa-edit" title="Editar Módulo"></i></a>
                    <a href="javascript:void(0)" class="mr-2" @click="deletarModulo(modulo, index)"><i class="fas fa-trash-alt" title="Excluir Módulo"></i></a>
                    <b-link v-b-toggle="'collapse-' + modulo.id">
                      <i class="fas fa-chevron-down"></i>
                    </b-link>
                  </div>
                </div>
                <b-collapse :id="'collapse-' + modulo.id" class="collapse">
                  <draggable
                    :list="licao_array"
                    :disabled="!enabledLicao"
                    class="list-group mt-2"
                    ghost-class="ghost"
                    @start="draggingLicao = true"
                    @end="draggingLicao = false"
                  >
                    <div v-for="(licao, index) in licao_array" :key="index">
                      <div class="list-group-item licao w-100" v-if="licao_array && licao.modulo_id == modulo.id">
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="flex-grow-1 mr-3">
                            <div class="d-flex align-items-center justify-content-between">
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center flex-column mr-3">
                                  <i class="fas fa-caret-up"></i>
                                  <i class="fas fa-caret-down"></i>
                                </div>
                                <p>{{ licao.licao }}</p>
                              </div>
                              <div>
                                <a href="javascript:void(0)" class="btn btn-secondary mr-2" @click="modalAssociarResumo(licao.id)"><i class="fas fa-plus"></i> Resumo</a>
                                <a href="javascript:void(0)" class="mr-2" @click="modalEdicaoLicao(licao)"><i class="fas fa-edit" title="Editar Lição"></i></a>
                                <a href="javascript:void(0)" class="mr-2" @click="deletarLicao(licao, index)"><i class="fas fa-trash-alt" title="Excluir Lição"></i></a>
                                <b-link v-b-toggle="'collapse-' + licao.id">
                                  <i class="fas fa-chevron-down"></i>
                                </b-link>
                              </div>
                            </div>
                            <b-collapse :id="'collapse-' + licao.id" class="collapse">
                              <draggable
                                :list="topico_array"
                                :disabled="!enabledTopico"
                                class="list-group mt-2"
                                ghost-class="ghost"
                                @start="draggingTopico = true"
                                @end="draggingTopico = false"
                              >
                              <div v-for="(topico, index) in topico_array" :key="index">
                                <div class="list-group-item topico" v-if="topico_array && topico.licao_id == licao.id">
                                  <span class="num-mod-lic">{{ topico.ordem_topico }}</span>{{ topico.topico}}
                                  <a href="javascript:void(0)" class="mr-2 float-right" @click="deletarTopico(topico, index)"><i class="fas fa-trash-alt" title="Excluir Tópico"></i></a>
                                  <a href="javascript:void(0)" class="mr-2 float-right" @click="modalEdicaoTopico(topico, modulo.id, licao.id)" v-if="topico.tipo_topico_id && topico.tipo_topico_id !== 7"><i class="fas fa-edit" title="Editar Tópico"></i></a>
                                </div>
                              </div>
                              </draggable>
                            </b-collapse>
                          </div>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </b-collapse >
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import ModalCadastroModulo from '@/modules/Conteudo/components/ModalCadastroModulo'
import ModalCadastroLicao from '@/modules/Conteudo/components/ModalCadastroLicao'
import ModalCadastroTopico from '@/modules/Conteudo/components/ModalCadastroTopico'
import ModalAssociaResumo from '@/modules/Conteudo/components/ModalAssociaResumo'
import draggable from 'vuedraggable'
import EmentaAPI from '@/api/ementa-api'
import LicaoAPI from '@/api/licao-api'
import ModuloAPI from '@/api/modulo-api'
import CursoAPI from '@/api/curso-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import PdfAPI from '@/api/pdf-api'

export default {
  name: 'CursoEmenta',
  components: { ModalCadastroModulo, ModalCadastroLicao, ModalCadastroTopico, ModalAssociaResumo, draggable },
  inheritAttrs: false,
  props: {
    curso_id: Number,
    curso_atual: Object,
    curso_edicao: Boolean,
    curso_edicao_volta: Boolean
  },
  data () {
    return {
      modulo_array: [],
      modulo_id: 0,
      licao_array: [],
      licao_id: 0,
      licao: {},
      enabledModulo: true,
      draggingModulo: false,
      enabledLicao: true,
      draggingLicao: false,
      enabledTopico: true,
      draggingTopico: false,
      moduloEdicao: null,
      licaoEdicao: null,
      topicoEdicao: null,
      indexLicaoArrayIdDeletar: [],
      topico: {
        topico_array: []
      },
      curso_atual_object: {},
      topico_array: [],
      indexTopicoArrayIdDeletar: [],
      resumosExistentes: []
    }
  },

  mounted () {
    if (this.curso_edicao) {
      this.curso_atual_object = this.curso_atual
      this.curso_atual_object.curso_ementa = this.curso_atual.curso_ementa.sort(function (a, b) {
        return a.ordem_modulo - b.ordem_modulo
      })
      this.curso_atual_object.curso_ementa = this.curso_atual.curso_ementa.sort(function (a, b) {
        return a.ordem_licao - b.ordem_licao
      })
      this.curso_atual_object.curso_ementa = this.curso_atual.curso_ementa.sort(function (a, b) {
        return a.ordem_topico - b.ordem_topico
      })
      this.curso_atual_object.curso_ementa.map(ementa => {
        Object.assign(ementa.licao, {
          modulo_id: ementa.modulo_id
        })
        Object.assign(ementa.topico, {
          ementa_id: ementa.id,
          curso_id: ementa.curso_id,
          modulo_id: ementa.modulo_id,
          licao_id: ementa.licao_id,
          ordem_modulo: ementa.ordem_modulo,
          ordem_licao: ementa.ordem_licao,
          ordem_topico: ementa.ordem_topico
        })
      })
      this.curso_atual_object.curso_ementa.map((ementa, index) => {
        if (!this.modulo_array.some(mod => {
          return ementa.modulo.id === mod.id
        })) {
          this.modulo_array.push(ementa.modulo)
        }
        if (!this.licao_array.some(lic => {
          return ementa.licao.id === lic.id
        })) {
          this.licao_array.push(ementa.licao)
        }
        if (!this.topico_array.some(top => {
          return ementa.topico.id === top.id
        })) {
          this.topico_array.push(ementa.topico)
        } else if (this.topico_array.some(top => {
          return top.tipo_topico_id === 7
        })) {
          this.topico_array.push(ementa.topico)
        }
      })
      this.topico.topico_array = this.topico_array
    }
  },

  watch: {
    licao_array () {
      let index = 1
      let entrou = 0
      this.modulo_array.map((modulo, indexModulo) => {
        this.licao_array.map((licao, indexLicao) => {
          this.topico.topico_array.map(topico => {
            if (topico.licao_id === licao.id && topico.modulo_id === modulo.id) {
              if (entrou) {
                index++
              }
              topico.ordem_licao = index
              entrou = 0
            }
          })
          entrou = 1
        })
        entrou = 0
        index = 0
      })
    },

    topico_array () {
      let index = 0
      this.modulo_array.map((modulo, indexModulo) => {
        this.licao_array.map((licao, indexLicao) => {
          this.topico.topico_array.map(topico => {
            if (topico.licao_id === licao.id && topico.modulo_id === modulo.id) {
              topico.ordem_topico = index + 1
              index++
            }
          })
          index = 0
        })
      })
    },

    modulo_array () {
      this.modulo_array.map((modulo, index) => {
        this.topico.topico_array.map(topico => {
          if (topico.modulo_id === modulo.id) {
            topico.ordem_modulo = index + 1
          }
        })
      })
    }

  },

  methods: {
    modalCadastrarModulo: function () {
      this.moduloEdicao = null

      this.$nextTick(() => {
        this.$refs.modalCadastroModulo.show()
      })
    },

    modalCadastrarLicao: function (id) {
      this.licaoEdicao = null
      this.modulo_id = id
      this.$nextTick(() => {
        this.$refs.modalCadastroLicao.show()
      })
    },

    modalAssociarResumo: function (id) {
      this.licao_id = id
      this.licao = {}
      LicaoAPI.listarPorId(id).then(data => {
        this.licao = data
        this.loaded = true
      })
      PdfAPI.listarTodos().then(data => {
        let arrayUnique = []
        data.map(item => {
          this.resumosExistentes.push(item)
          arrayUnique.push(item.titulo)
        })
      })

      this.$nextTick(() => {
        this.$refs.modalAssociaResumo.show()
      })
    },

    atualizaLicao: function () {
      LicaoAPI.listarPorId(this.licao.id).then(data => {
        this.licao = data
        this.loaded = true
      })
    },

    moduloSalvo: function (modulo) {
      this.moduloEdicao = null
      this.modulo_array = modulo
    },

    licaoSalva: function (licao, topico) {
      this.licaoEdicao = null
      this.licao_array = licao
      this.topico.topico_array.push(topico)
      this.modulo_array.map((modulo, index) => {
        this.topico.topico_array.map(topico => {
          if (topico.modulo_id === modulo.id) {
            topico.ordem_modulo = index + 1
          }
        })
      })
    },

    licaoEditada: function (licao) {
      this.licaoEdicao = null
      this.licao_array = licao
    },

    topicoEditado: function (topico) {
      this.topicoEdicao = null
      this.topico_array = topico
    },

    resumosAssociados: function () {
      this.licaoId = null
    },

    modalEdicaoModulo: function (modulo) {
      this.moduloEdicao = modulo

      this.$nextTick(() => {
        this.$refs.modalCadastroModulo.show()
      })
    },

    modalEdicaoLicao: function (licao) {
      this.licaoEdicao = licao

      this.$nextTick(() => {
        this.$refs.modalCadastroLicao.show()
      })
    },

    modalEdicaoTopico: function (topico, moduloId, licaoId) {
      this.topicoEdicao = topico
      this.licao_id = licaoId
      this.modulo_id = moduloId
      this.$nextTick(() => {
        this.$refs.modalCadastroTopico.show()
      })
    },

    deletarModulo: function (modulo, index) {
      this.licao_array.map((licao, index) => {
        if (licao.modulo_id === modulo.id) {
          this.indexLicaoArrayIdDeletar.push(index)
        }
      })
      Swal.fire({
        title: 'Você deseja excluir esse módulo?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir módulo!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          ModuloAPI.deletar(modulo, this.curso_id).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Módulo deletado com sucesso'
            }).then(() => {
              this.indexLicaoArrayIdDeletar.reverse().map(id => {
                this.licao_array.splice(id, 1)
              })
              this.topico_array.map((topico, indexTopico) => {
                if (topico.modulo_id === modulo.id) {
                  this.topico_array.splice(indexTopico, 1)
                }
              })
              this.modulo_array.splice(index, 1)
              this.indexLicaoArrayIdDeletar = []
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
          loader.hide()
        }
      })
    },

    deletarLicao: function (licao, index) {
      this.topico_array.map((topico, index) => {
        if (topico.licao_id === licao.id) {
          this.indexTopicoArrayIdDeletar.push(index)
        }
      })
      Swal.fire({
        title: 'Você deseja excluir essa lição?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir lição!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          LicaoAPI.deletar(licao, this.curso_id).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Lição deletada com sucesso'
            }).then(() => {
              this.indexTopicoArrayIdDeletar.reverse().map(id => {
                this.topico_array.splice(id, 1)
              })
              this.topico_array.map((topico, indexTopico) => {
                if (topico.licao_id === licao.id) {
                  this.topico_array.splice(indexTopico, 1)
                }
              })
              this.licao_array.splice(index, 1)
              this.indexTopicoArrayIdDeletar = []
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
          loader.hide()
        }
      })
    },

    deletarTopico: function (topico, index) {
      Swal.fire({
        title: 'Você deseja excluir esse tópico?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir tópico!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          EmentaAPI.deletar(topico, topico.curso_id, topico.modulo_id, topico.licao_id).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Tópico deletado com sucesso'
            }).then(() => {
              this.topico_array.map((top, indexTopico) => {
                if (top.id === topico.id) {
                  this.topico_array.splice(indexTopico, 1)
                }
              })
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
          loader.hide()
        }
      })
    },

    cadastrarEmenta: function () {
      const loader = this.$loading.show()

      EmentaAPI.salvar(this.topico).then(data => {
        loader.hide()

        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Ementa criada com sucesso'
        }).then(() => {
          this.$router.push('/conteudo/curso')
        })
      }).catch(error => ResponseUtils.handleError(error, loader))
    },

    editarEmenta: function (valor) {
      if (this.topico.topico_array.length === 0) {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Não existe tópico para criar a ementa'
        })
      } else {
        const loader = this.$loading.show()
        EmentaAPI.editar(this.topico).then(data => {
          loader.hide()
          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Ementa atualizada com sucesso'
          }).then(() => {
            if (valor) {
              CursoAPI.listarCursoPorId(this.curso_id).then(result => {
                Object.assign(this.curso_atual_object, result)
              })
              this.$router.push({ name: 'adicionar-curso',
                params: {
                  curso_atual: this.curso_atual_object,
                  curso_edicao: true,
                  curso_edicao_volta: this.curso_edicao_volta
                }
              })
            } else {
              this.$router.push('/conteudo/curso')
            }
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
